"use client"

import { useEffect, useState } from "react"
import "./Projects.css"

const Projects = ({ language }) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  const translations = {
    en: {
      heroTitle: "Constituency Projects",
      heroDescription:
        "Transforming Bichi Federal Constituency through strategic development projects, infrastructure improvements, and community empowerment initiatives.",
      overviewTitle: "Development Overview",
      overviewDescription:
        "Recent and ongoing projects initiated or facilitated by Hon. Abubakar Kabir Abubakar for his constituency, focusing on education, healthcare, infrastructure, and economic empowerment.",
      projects: [
        {
          title: "Bichi Modern City Project",
          description:
            "Construction of 2,000 housing units in Bichi. A committee was established in July 2025 to oversee the project's construction.",
          category: "Infrastructure",
          categoryClass: "infrastructure-category",
        },
        {
          title: "Interlocking Pavement Project",
          description: "Interlocking pavement project in Bichi town with an appropriated amount of ₦53 million.",
          category: "Infrastructure",
          categoryClass: "infrastructure-category",
          amount: "₦53 Million",
        },
        {
          title: "University Students Scholarship",
          description:
            "In August 2025, he paid the 2024/2025 academic session's school fees for 144 Bichi indigenes studying at Bayero University, Kano. His foundation has also provided financial support to hundreds of science and technical school students.",
          category: "Education",
          categoryClass: "education-category",
        },
        {
          title: "North-West Empowerment Program",
          description:
            "In February 2025, he provided a ₦900 million empowerment program for the Tinubu Support Group in the North-West, which included the distribution of items like motorcycles and sewing machines. He has also funded youth and women empowerment grants.",
          category: "Empowerment",
          categoryClass: "empowerment-category",
          amount: "₦900 Million",
        },
        {
          title: "Educational Transportation",
          description:
            "In February 2025, he facilitated the distribution of 13 buses to various universities and colleges in Kano State and 11 tractors and combine harvesters to his constituents.",
          category: "Education",
          categoryClass: "education-category",
        },
        {
          title: "AKTH Trauma Center",
          description:
            "He facilitated the construction of a five-story Accident and Emergency and Trauma Center at AKTH, which he inspected in September 2025. This project is part of a larger investment in the hospital, which has attracted over ₦26 billion in projects.",
          category: "Healthcare",
          categoryClass: "healthcare-category",
          amount: "₦26 Billion",
        },
        {
          title: "Bichi Stadium Construction",
          description:
            "As of January 2025, he has been involved in inspecting the construction of an 18,000-capacity stadium in Bichi.",
          category: "Sports",
          categoryClass: "sports-category",
        },
        {
          title: "Road Reconstruction",
          description:
            "He has spearheaded the reconstruction of roads like the Santar-Namama Road, enhancing access to essential facilities. In his previous role as Chairman of the House Committee on Works (2019-2023), he advocated for major projects, including the Abuja-Kano Expressway and the Kano Light Rail.",
          category: "Infrastructure",
          categoryClass: "infrastructure-category",
        },
        {
          title: "Modern Markets Establishment",
          description:
            "He has overseen the establishment of modern markets in his constituency, such as the Kabiru Abubakar Bichi Ultra Modern Market, to stimulate local commerce.",
          category: "Infrastructure",
          categoryClass: "infrastructure-category",
        },
        {
          title: "E-Library Construction",
          description:
            "He is facilitating the construction of an E-Library in Bichi, which will provide modern learning resources and promote literacy.",
          category: "Education",
          categoryClass: "education-category",
        },
        {
          title: "Youth Employment Initiative",
          description:
            "Bichi has employed approximately 100 aides to assist with constituency affairs and provide youth empowerment opportunities.",
          category: "Empowerment",
          categoryClass: "empowerment-category",
        },
        {
          title: "International Scholarship Program",
          description:
            "He has consistently sponsored students from Bichi LGA pursuing various degrees in Nigeria and abroad through the Kabiru Abubakar Bichi Foundation.",
          category: "Education",
          categoryClass: "education-category",
        },
        {
          title: "Educational Materials Distribution",
          description:
            "In February 2021, he donated educational materials valued at millions of Naira to 1,340 students in the Bichi Federal Constituency.",
          category: "Education",
          categoryClass: "education-category",
        },
        {
          title: "Bichi First FC",
          description:
            "He is the president of Bichi First FC, a newly established football club aimed at empowering young people through sports and discouraging illicit activities. The club recently purchased a slot in the Nigerian National League for the 2025/2026 season.",
          category: "Sports",
          categoryClass: "sports-category",
        },
        {
          title: "Agricultural Equipment Distribution",
          description:
            "In July 2025, Abubakar Kabir Abubakar Bichi donated 13 brand-new buses to universities and colleges in Kano and 11 tractors and 4 combine harvesters to his constituents in the Bichi Local Government Area.",
          category: "Infrastructure",
          categoryClass: "infrastructure-category",
        },
        {
          title: "Malaysia Postgraduate Program",
          description:
            "In October 2024, 21 constituents were sent to the Universiti Technologi Malaysia (UTM) to pursue postgraduate degrees in fields like engineering and information technology. Each student received a laptop, settlement allowance, and monthly stipends in addition to tuition.",
          category: "Education",
          categoryClass: "education-category",
        },
        {
          title: "Modern Juma'at Mosque",
          description:
            "Hon. Abubakar Kabir Abubakar (Abba Bichi) built a modern Juma'at mosque with a capacity of 3,000 worshippers in the Bichi Local Government Area of Kano State. The mosque is part of a larger complex that also includes an Islamiyyah school and toilet facilities.",
          category: "Infrastructure",
          categoryClass: "infrastructure-category",
        },
      ],
    },
    ha: {
      heroTitle: "Ayyukan Mazaba",
      heroDescription:
        "Canza Mazabar Bichi ta hanyar ayyukan ci gaba, inganta gine-gine, da shirye-shiryen karfafa al'umma.",
      overviewTitle: "Bayyani na Ci Gaba",
      overviewDescription:
        "Ayyukan da aka fara ko kuma aka sauƙaƙa kwanan nan da Malam Abubakar Kabir Abubakar ya yi wa mazabarsa, da mayar da hankali kan ilimi, lafiya, gine-gine, da karfafa tattalin arziki.",
      projects: [
        {
          title: "Aikin Birnin Bichi na Zamani",
          description: "Gina gidaje 2,000 a Bichi. An kafa kwamiti a watan Yuli 2025 don kula da ginin aikin.",
          category: "Gine-gine",
          categoryClass: "infrastructure-category",
        },
        {
          title: "Aikin Shimfidar Hanyoyi",
          description: "Aikin shimfidar hanyoyi a garin Bichi da kudaden da aka keɓe na Naira miliyan 53.",
          category: "Gine-gine",
          categoryClass: "infrastructure-category",
          amount: "₦53 Miliyan",
        },
        {
          title: "Tallafin Daliban Jami'a",
          description:
            "A watan Agusta 2025, ya biya kudin karatu na zangon 2024/2025 ga dalibai 144 na Bichi da ke karatu a Jami'ar Bayero, Kano. Gidauniyarsa ta kuma ba da tallafin kudi ga daruruwan daliban makarantun kimiyya da fasaha.",
          category: "Ilimi",
          categoryClass: "education-category",
        },
        {
          title: "Shirin Karfafawa na Arewa-Yamma",
          description:
            "A watan Fabrairu 2025, ya samar da shirin karfafawa na Naira miliyan 900 ga Kungiyar Magoya Bayan Tinubu a Arewa-Yamma, wanda ya hada da rarraba kayayyaki kamar babura da injunan dinki. Ya kuma ba da tallafin matasa da mata.",
          category: "Karfafawa",
          categoryClass: "empowerment-category",
          amount: "₦900 Miliyan",
        },
        {
          title: "Motocin Ilimi",
          description:
            "A watan Fabrairu 2025, ya sauƙaƙe rarraba motoci 13 ga jami'o'i da kwalejoji daban-daban a Jihar Kano da tarakta 11 da injunan girbi ga mazabansa.",
          category: "Ilimi",
          categoryClass: "education-category",
        },
        {
          title: "Cibiyar Gaggawa ta AKTH",
          description:
            "Ya sauƙaƙe ginin cibiyar gaggawa mai hawa biyar a AKTH, wanda ya duba a watan Satumba 2025. Wannan aikin wani bangare ne na babban saka hannun jari a asibitin, wanda ya jawo sama da Naira biliyan 26.",
          category: "Lafiya",
          categoryClass: "healthcare-category",
          amount: "₦26 Biliyan",
        },
        {
          title: "Ginin Filin Wasa na Bichi",
          description:
            "Tun daga watan Janairu 2025, ya shiga cikin duba ginin filin wasa mai karfin mutane 18,000 a Bichi.",
          category: "Wasanni",
          categoryClass: "sports-category",
        },
        {
          title: "Sake Gina Hanyoyi",
          description:
            "Ya jagoranci sake gina hanyoyi kamar Hanyar Santar-Namama, don inganta hanyar zuwa muhimman wurare. A matsayinsa na tsohon Shugaban Kwamitin Ayyuka na Majalisar (2019-2023), ya ba da shawara kan manyan ayyuka, ciki har da Babbar Hanyar Abuja-Kano da Jirgin Kasa na Kano.",
          category: "Gine-gine",
          categoryClass: "infrastructure-category",
        },
        {
          title: "Kafa Kasuwanni na Zamani",
          description:
            "Ya kula da kafa kasuwanni na zamani a mazabarsa, kamar Kasuwar Kabiru Abubakar Bichi Ultra Modern Market, don karfafa kasuwanci na gida.",
          category: "Gine-gine",
          categoryClass: "infrastructure-category",
        },
        {
          title: "Ginin E-Library",
          description:
            "Yana sauƙaƙe ginin E-Library a Bichi, wanda zai samar da kayan koyo na zamani da kuma inganta karatu.",
          category: "Ilimi",
          categoryClass: "education-category",
        },
        {
          title: "Shirin Aikin Matasa",
          description:
            "Bichi ya dauki mataimaka kusan 100 don taimakawa a harkokin mazaba da kuma samar da damar karfafa matasa.",
          category: "Karfafawa",
          categoryClass: "empowerment-category",
        },
        {
          title: "Shirin Tallafin Karatu na Duniya",
          description:
            "Ya ci gaba da tallafa wa dalibai daga Karamar Hukumar Bichi da ke neman digiri daban-daban a Najeriya da waje ta hanyar Gidauniyar Kabiru Abubakar Bichi.",
          category: "Ilimi",
          categoryClass: "education-category",
        },
        {
          title: "Rarraba Kayan Ilimi",
          description:
            "A watan Fabrairu 2021, ya ba da gudummawar kayan ilimi da darajarsu ta kai miliyoyin Naira ga dalibai 1,340 a Mazabar Bichi.",
          category: "Ilimi",
          categoryClass: "education-category",
        },
        {
          title: "Bichi First FC",
          description:
            "Shi ne shugaban Bichi First FC, sabuwar kungiyar kwallon kafa da aka kafa don karfafa matasa ta hanyar wasanni da kuma hana ayyukan da ba su dace ba. Kungiyar ta sayi wurin a Nigerian National League na kakar 2025/2026.",
          category: "Wasanni",
          categoryClass: "sports-category",
        },
        {
          title: "Rarraba Kayan Aikin Noma",
          description:
            "A watan Yuli 2025, Abubakar Kabir Abubakar Bichi ya ba da gudummawar motoci 13 ga jami'o'i da kwalejoji a Kano da tarakta 11 da injunan girbi 4 ga mazabansa a Karamar Hukumar Bichi.",
          category: "Gine-gine",
          categoryClass: "infrastructure-category",
        },
        {
          title: "Shirin Digiri na Biyu na Malaysia",
          description:
            "A watan Oktoba 2024, an aika mazaba 21 zuwa Jami'ar Fasaha ta Malaysia (UTM) don neman digiri na biyu a fannoni kamar injiniya da fasahar bayanai. Kowane dalibi ya karbi kwamfuta, tallafin zama, da tallafin wata-wata ban da kudin karatu.",
          category: "Ilimi",
          categoryClass: "education-category",
        },
        {
          title: "Masallacin Juma'a na Zamani",
          description:
            "Malam Abubakar Kabir Abubakar (Abba Bichi) ya gina masallacin Juma'a na zamani mai karfin mutane 3,000 a Karamar Hukumar Bichi ta Jihar Kano. Masallacin wani bangare ne na babban gini wanda ya hada da makarantar Islamiyya da wuraren bayan gida.",
          category: "Gine-gine",
          categoryClass: "infrastructure-category",
        },
      ],
    },
  }

  const t = translations[language]

  return (
    <div className="projects">
      {/* Hero Section */}
      <section className="projects-hero">
        <div className={`projects-hero-content ${isVisible ? "fade-in" : ""}`}>
          <h1>{t.heroTitle}</h1>
          <p>{t.heroDescription}</p>
        </div>
      </section>

      {/* Projects Content */}
      <div className="projects-content">
        {/* Overview Section */}
        <section className={`projects-overview ${isVisible ? "slide-in-up" : ""}`}>
          <h2>{t.overviewTitle}</h2>
          <p>{t.overviewDescription}</p>
        </section>

        {/* Projects Grid */}
        <div className={`projects-grid ${isVisible ? "slide-in-up" : ""}`}>
          {t.projects.map((project, index) => {
            // Remove money for items 2, 4, 6
            const hideAmount = [1, 3, 5].includes(index);
            return (
              <div key={index} className="project-card">
                {/* Removed project-number and project-category */}
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                {project.amount && !hideAmount ? null : null}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  )
}

export default Projects
